module.exports = __webpack_public_path__ + "img/vertical_7_5_3009.c67c6a98.png";